import { render, staticRenderFns } from "./BalanceInfo.vue?vue&type=template&id=7ec1063a&scoped=true&"
import script from "./BalanceInfo.vue?vue&type=script&lang=js&"
export * from "./BalanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./BalanceInfo.vue?vue&type=style&index=0&id=7ec1063a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec1063a",
  null
  
)

export default component.exports